var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"height":`${_vm.height}${_vm.units}`,"src":_vm.resSrc,"width":`${_vm.width}${_vm.units}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }